import instance from '../api';

export async function downloadFile(url: string, displayName: string) {
  try {
    const { data } = await instance.get(url, {
      responseType: 'blob',
      headers: {
        'Cache-Control': 'max-age=0',
      },
    });

    let fileExtention;
    if (data.type === 'application/pdf') fileExtention = '.pdf';
    if (
      data.type ===
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    )
      fileExtention = '.docx';
    if (data.type === 'application/msword') fileExtention = '.doc';

    const downloadUrl = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', `${displayName}${fileExtention}`);
    document.body.appendChild(link);

    link.click();
    setTimeout(function () {
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    }, 100);
  } catch (err) {
    throw err;
  }
}
